import React from 'react';
import pluralize from 'pluralize';

import type { Memory } from '../../types/memory';

const MemoryCardStats: React.FC<{ memory: Memory }> = ({ memory }) => {
  return (
    <div className="memory-card-stats wa-cluster wa-gap-m">
      <div id={`memory-${memory.id}-reactions`} className="wa-cluster wa-gap-2xs">
        <i className="fa-light fa-heart memory-card-stat-icon" />
        <span className="memory-card-stat">{memory.reactions_count}</span>
        <wa-tooltip for={`memory-${memory.id}-reactions`} placement="top">
          {pluralize('reaction', memory.reactions_count, true)}
        </wa-tooltip>
      </div>
      <div id={`memory-${memory.id}-comments`} className="wa-cluster wa-gap-2xs" title="Comments">
        <i className="fa-light fa-comment memory-card-stat-icon" />
        <span className="memory-card-stat">{memory.comments_count}</span>
        <wa-tooltip for={`memory-${memory.id}-comments`} placement="top">
          {pluralize('comment', memory.comments_count, true)}
        </wa-tooltip>
      </div>
      <div id={`memory-${memory.id}-views`} className="wa-cluster wa-gap-2xs">
        <i className="fa-light fa-eye memory-card-stat-icon" />
        <span className="memory-card-stat">{memory.views_count}</span>
        <wa-tooltip for={`memory-${memory.id}-views`} placement="top">
          {pluralize('view', memory.views_count, true)}
        </wa-tooltip>
      </div>
      <div id={`memory-${memory.id}-shares`} className="wa-cluster wa-gap-2xs">
        <i className="fa-light fa-share memory-card-stat-icon" />
        <span className="memory-card-stat">{memory.shares_count}</span>
        <wa-tooltip for={`memory-${memory.id}-shares`} placement="top">
          {pluralize('share', memory.shares_count, true)}
        </wa-tooltip>
      </div>
    </div>
  );
}

export default MemoryCardStats;
